<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="880px" overlay-color="black" overlay-opacity="0.65">
      <template v-slot:activator="{ on }"> </template>
      <v-card>
        <v-card-title class="title__wrapper">
          <p class="title">目標を編集</p>
          <span class="title__line"></span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-text-field
              v-model="input.name"
              label="目標名"
              class="name__input"
              maxlength="15"
              counter="15"
              color="#56a5bf"
            >
            </v-text-field>
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="input.deadline"
              transition="scale-transition"
              min-width="290px"
              offset-y
              absolute
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="input.deadline"
                  label="期日"
                  readonly
                  v-on="on"
                  :rules="deadlineRules"
                  color="#56a5bf"
                  class="deadline__input"
                  ><v-icon slot="prepend" :class="{ '--filled': input.deadline !== '' }"
                    >mdi-calendar-clock</v-icon
                  ></v-text-field
                >
              </template>
              <v-date-picker
                v-model="input.deadline"
                scrollable
                class="deadline__calender-input"
                locale="ja"
                color="#56a5bf"
              >
                <v-spacer></v-spacer>
                <v-btn text color="#56a5bf" @click="dateMenu = false">
                  キャンセル
                </v-btn>
                <v-btn color="#ff7e2f" dark @click="$refs.dateMenu.save(input.deadline)">
                  保存
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="colorMenu"
              v-model="colorMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="input.color"
              transition="scale-transition"
              min-width="290px"
              offset-y
              absolute
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="input.color"
                  label="色を設定できます"
                  readonly
                  v-on="on"
                  color="#56a5bf"
                  class="color__input"
                  ><v-icon slot="prepend" :class="{ '--filled': input.color !== '' }"
                    >mdi-palette-outline</v-icon
                  ></v-text-field
                >
              </template>
              <v-color-picker show-swatches hide-inputs v-model="input.color"></v-color-picker>
              <div class="color-menu__button-wrapper">
              <v-btn text color="#56a5bf" @click="colorMenu = false">
                キャンセル
              </v-btn>
              <v-btn color="#ff7e2f" class="color-menu__button-store" dark @click="$refs.colorMenu.save(input.color)">
                保存
              </v-btn>
              </div>
            </v-menu>
            <v-textarea
              v-model="input.description"
              label="説明"
              counter
              auto-grow=""
              no-resize
              outlined
              maxlength="150"
              color="#56a5bf"
              class="description__input"
              ><v-icon slot="prepend" :class="{ '--filled': input.memo !== '' }"
                >mdi-file-document-outline</v-icon
              ></v-textarea
            >
          </v-container>
        </v-card-text>

        <v-row class="submitButton__wrapper">
          <v-btn color="#ff7e2f" class="submitButton" dark @click="handleSubmitButtonClick">
            保存
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "EditTargetModal",
  data: () => ({
    dialog: false,
    input: {
      name: "",
      deadline: "",
      description: "",
      targetRank: "",
      color: ""
    },
    targetRankOptions: [],
    dateMenu: "",
    colorMenu: "",
    deadlineRules: [v => v.length >= 1 || "期日を設定してください"],
    targetRankRules: [v => v !== "" || "目標を設定してください"],
    memoRules: [v => v.length <= 150 || ""]
  }),
  computed: {
    targetsData() {
      return this.$store.getters.targetsData;
    }
  },
  props: ["targetData"],
  methods: {
    openDialog() {
      this.dialog = true;
    },
    handleSubmitButtonClick() {
      this.dialog = false;
      this.$emit(
        "submit",
        this.input.name,
        this.input.deadline,
        this.input.description,
        this.input.color,
        this.input.targetRank
      );
    }
  },
  watch: {
    targetData: function() {
      this.input.name = this.targetData.name;
      this.input.description = this.targetData.description;
      this.input.deadline = this.targetData.deadline;
      this.input.targetRank = this.targetData.targetRank;
      this.input.color = this.targetData.color;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  width: 750px;
  height: 670px;
}
::v-deep .v-icon {
  &.--filled {
    color: $primary !important;
  }
}
.v-card {
  height: 670px;
  width: 750px;
  display: grid;
}
::v-deep .v-label {
  font-size: 14px !important;
}

.title__wrapper {
  justify-content: center;
  padding-top: 35px !important;
  flex-direction: column;
}
.v-application .title {
  font-size: 30px !important;
  margin-bottom: 11px;
}

.title__line {
  width: 150px;
  border-bottom: 2px solid $primary;
}

.name__input {
  width: 620px;
  &.v-input {
    font-size: 24px !important;
    ::v-deep .v-text-field__slot {
      padding: 4px 0px 4px 12px;
    }
  }
}

.deadline__input {
  width: 200px;
  padding-top: 50px;
}
.deadline__calender-input {
  width: 300px;
  height: 430px;
}
.description__input {
  padding-top: 50px;
  padding-bottom: 50px;
  ::v-deep .v-text-field__slot {
    height: 100px;
  }
}

.submitButton__wrapper {
  justify-content: flex-end;
  width: 100%;
}

.submitButton {
  width: 110px;
}

.color-menu__button-wrapper{
    background: white;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.color-menu__button-store{
  margin-right: 10px;
}
</style>
